import { render, staticRenderFns } from "./GroupManage.vue?vue&type=template&id=13e87d06&scoped=true"
import script from "./GroupManage.vue?vue&type=script&lang=js"
export * from "./GroupManage.vue?vue&type=script&lang=js"
import style0 from "./GroupManage.vue?vue&type=style&index=0&id=13e87d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e87d06",
  null
  
)

export default component.exports